<script setup lang="js">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useSubmoduleStore } from '@/stores/submodule.store';
import { useRouteParams } from '@vueuse/router';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';

const submoduleStore = useSubmoduleStore();
const submoduleGroupId = useRouteParams('submoduleGroupId');
const { closeModal } = useModal();

const { createEndSubmoduleRequest, endSubmoduleTypeList } = storeToRefs(submoduleStore);

const name = ref(null);
const description = ref(null);
const type = ref(null);
const url = ref(null);

function createSubmodule() {
  submoduleStore.createEndSubmodule(submoduleGroupId.value, name.value, description.value, type.value, url.value).then(() => {
    closeModal();
  });
}
function isErrorField(fieldName) {
  if (createEndSubmoduleRequest.value.error?.errors) {
    return createEndSubmoduleRequest.value.error.errors[fieldName] || false;
  }
}
function isNotFieldError() {
  if (!createEndSubmoduleRequest.value.error?.errors) {
    return createEndSubmoduleRequest.value.error;
  }
}
</script>

<template>
  <ModalTemplateSide @submit="createSubmodule" :disableButtons="createEndSubmoduleRequest.isLoading">
    <template v-slot:title>Создать субмодуль</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Наименование</label>
        <input v-model="name" type="text" class="form-control" :class="{ error: isErrorField('name') }" />
        <p v-if="isErrorField('name')" class="error-mesage">
          <span v-for="error in isErrorField('name')">{{ error }}</span>
        </p>
      </div>
      <div class="mt-3">
        <label class="form-label">Описание</label>
        <textarea v-model="description" class="form-control" :class="{ error: isErrorField('description') }"></textarea>
        <p v-if="isErrorField('description')" class="error-mesage">
          <span v-for="error in isErrorField('description')">{{ error }}</span>
        </p>
      </div>
      <div class="mt-3">
        <label class="form-label">Тип</label>
        <select v-model="type" class="form-select" :class="{ 'error': isErrorField('type') }">
          <option v-for="typeKey in Object.keys(endSubmoduleTypeList)" :key="typeKey" :value="typeKey">
            {{ endSubmoduleTypeList[typeKey] }}
          </option>
        </select>
        <p v-if="isErrorField('type')" class="error-mesage">
          <span v-for="error in isErrorField('type')">{{ error }}</span>
        </p>
      </div>
      <div class="mt-3">
        <label class="form-label">Url</label>
        <input v-model="url" type="text" class="form-control" :class="{ error: isErrorField('url') }" />
        <p v-if="isErrorField('url')" class="error-mesage">
          <span v-for="error in isErrorField('url')">{{ error }}</span>
        </p>
      </div>
      <p v-if="isNotFieldError()" class="error-mesage">
        <span v-for="error in isNotFieldError()">{{ error }}</span>
      </p>
    </template>
    <template v-slot:submit>
      <img v-if="createEndSubmoduleRequest.isLoading" class="loader" src="@/assets/img/loader.gif" alt="loader.gif" />
      <div v-else>Создать</div>
    </template>
  </ModalTemplateSide>
</template>
